import { FlexContainer } from '@/ui/styled-ui';
import styled from 'styled-components';

export const PageContainer = styled(FlexContainer)`
  gap: var(--medium-padding);
  width: 100%;
`;

export const SectionTitle = styled.h2`
  font-size: var(--heading-small-font-size);
  font-weight: 700;
  margin: 0;
`;

export const Banner = styled.div<{ variant: 'success' | 'warning' }>`
  background-color: ${({ variant }) =>
    variant === 'success' ? 'var(--green-pale)' : 'var(--red-pale)'};
  border-radius: var(--small-border-radius);
  display: flex;
  align-items: center;
  gap: var(--small-padding);
  padding: var(--small-padding) var(--medium-padding);
  width: 100%;
`;

export const BannerIcon = styled.div<{ variant: 'success' | 'warning' }>`
  width: var(--semi-big-padding);
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: ${({ variant }) =>
      variant === 'success' ? 'var(--green-main)' : 'var(--red-main)'};
    font-size: 18px;
  }
`;

export const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 500;
`;

export const BannerTitle = styled.span`
  font-weight: 700;
`;

export const TableLog = styled.div`
  background-color: var(--beige-main);
  border-radius: var(--semi-medium-border-radius);
  padding: var(--big-padding);
  display: flex;
  flex-direction: column;
  gap: var(--default-padding);
  width: 100%;
`;

export const ErrorCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--small-padding);
  width: 100%;
`;

export const CategoryTitle = styled.div`
  font-size: var(--medium-font-size);
  line-height: var(--medium-line-height);
  font-weight: 700;
  color: var(--black-main);
`;

export const CategoryMeta = styled.span`
  font-size: var(--xsmall-font-size);
  line-height: var(--xsmall-line-height);
  color: var(--gray-deep);
`;

export const ErrorTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid var(--gray-dark);
    padding: var(--medium-padding);
    text-align: left;
    vertical-align: middle;
  }

  th {
    font-size: var(--xsmall-font-size);
    line-height: var(--xsmall-line-height);
    font-weight: 700;
    color: var(--black-main);
    height: 50px;
    background-color: var(--white-main);
  }

  td {
    font-size: var(--small-font-size);
    line-height: var(--small-line-height);
    font-weight: 500;
    color: var(--black-main);
    height: 53px;
    word-break: break-word;
  }

  th:first-child,
  td:first-child {
    width: 256px;
  }

  td:last-child {
    white-space: pre-wrap;
  }
`;

export const RowErrorCell = styled.p`
  margin: 0;

  &::first-letter {
    text-transform: uppercase;
  }

  &:not(:last-child) {
    margin-bottom: var(--xxsmall-padding);
  }
`;

export const EmptyStateCard = styled.div`
  background-color: var(--beige-main);
  border-radius: var(--small-border-radius);
  padding: calc(var(--big-padding) + var(--large-padding)) var(--big-padding);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--small-padding);
  align-items: center;
  text-align: center;

  i {
    font-size: 60px;
    color: var(--gray-darker);
  }

  span {
    font-size: var(--medium-font-size);
    line-height: var(--medium-line-height);
    font-weight: 700;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--small-padding);
`;
